import { Params } from '@src/pages/Workspace/types'
import { getLoggedIn } from '@src/state/auth/selectors'
import { onClickNavLink } from '@src/state/document/actions'
import { getSiteConfig } from '@src/state/site/selectors'
import { SiteConfig, SiteState } from '@src/state/site/types'
import { RootState } from '@src/state/types'
import { wordsToTestId } from '@src/utils'
import { Location } from 'history'
import * as React from 'react'
import { connect } from 'react-redux'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { Dispatch } from 'redux'
import { topNavRoutes } from '../routes'
import { getTopNavRoutes } from '../utils'
import { TopHeaderNav, TopNavLink } from './styles'

interface TopNavProps {
  loggedIn?: boolean
  site: SiteState
  siteConfig: SiteConfig
  location: Location<any>
}

interface DispatchProps {
  onClickNavLink: (label: string) => void
}

export const TopNavHeader: React.FC<TopNavProps & DispatchProps> = ({
  loggedIn,
  site,
  siteConfig,
  location,
  onClickNavLink,
}) => {
  const navRoutes = getTopNavRoutes(topNavRoutes, loggedIn, siteConfig, site)

  if (!navRoutes.length) {
    return null
  }

  return (
    <TopHeaderNav>
      {navRoutes.map(route => (
        <TopNavLink
          data-test={`nav-link-${wordsToTestId(route.name)}`}
          key={route.name}
          href={route.href}
          isActive={location.pathname === route.href}
          onClick={() => onClickNavLink(route.name)}
        >
          {route.name}
        </TopNavLink>
      ))}
    </TopHeaderNav>
  )
}

const mapStateToProps = (state: RootState, ownProps: RouteComponentProps<Params>) => ({
  loggedIn: getLoggedIn(state),
  site: state.site,
  siteConfig: getSiteConfig(state),
  location: ownProps.location,
})

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
  onClickNavLink: (label: string) => {
    dispatch(onClickNavLink({ label }))
  },
})

export default withRouter(
  connect<TopNavProps, DispatchProps, RouteComponentProps<Params>>(
    mapStateToProps,
    mapDispatchToProps
  )(TopNavHeader)
)



// WEBPACK FOOTER //
// ./src/components/Header/TopNavHeader/index.tsx